import React from 'react';
import Input from '../elements/Input';

const MiscellaneousItemsForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Item Type"
      value={formData.itemType || ''}
      onChange={e => setFormData({ ...formData, itemType: e.target.value })}
      placeholder="e.g. Pet Care, Gym Membership, Personal Message"
      error={formError.itemType}
    />
    <Input
      label="Description"
      value={formData.description || ''}
      onChange={e => setFormData({ ...formData, description: e.target.value })}
      placeholder="e.g. Dog feeding schedule, Gold's Gym annual, Message for family"
      error={formError.description}
    />
    <Input
      label="Notes / Wishes"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="e.g. Leave message for family, special instructions for pet care"
      error={formError.notes}
    />
  </>
);

export default MiscellaneousItemsForm;